/**
 * A place for storing urls for later use in XHR requests.
 */

import { BaseStore } from 'fluxible/addons';

class UrlStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.urls = new Map();
    }

    loadUrls(payload) {
        Object.keys(payload.urls).map(key => {
            this.urls.set(key, urls[key]);
        });
    }

    urlFor(key) {
        return this.urls.get(key);
    }
}

UrlStore.storeName = 'UrlStore';
UrlStore.handlers = {
    LOAD_URLS: 'loadUrls'
};

export default UrlStore;



// WEBPACK FOOTER //
// ./js/launch/stores/UrlStore.js